import React, { useState } from "react";
import { IoMdMenu } from "react-icons/io";
import img from "../../../Assets/Image/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { LoadingWait } from "./LoadingWait";
import { SuccessPopUp } from "./SuccessPopUp";

function Header({ getActiveClass }) {

    const [isDropdownOpen, setDropdownOpen] = useState(false); // State to toggle dropdown visibility

    const toggleDropdown = () => {
        setDropdownOpen(!isDropdownOpen);
    };

    const navtoAdmin = useNavigate();
    const handleLogout = () => {
        alert("Logged out");
        sessionStorage.removeItem('tokenKey')
        navtoAdmin('/admin');
        window.location.reload();
    };

    const BASE_URL = process.env.REACT_APP_PP_URL;
    const token = sessionStorage.getItem('tokenKey');
    const [isLoading, setIsLoading] = useState(false);

    const [action, setAction] = useState();
    const [showPopup, setShowPopup] = useState(false);

    const onClose = () => {
        setShowPopup(false);
    }

    const refresh = async () => {
        setIsLoading(true);
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/configuration/refresh-configuration`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setShowPopup(true)
                setAction(getRes.message);
            } else {
                setShowPopup(true)
                setAction(getRes.message);
            }
        } catch (e) {
            console.log(e, "error in refresh")
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="headerr">
                <div className="row">
                    <div className="container">
                        {/* Menu Icon */}
                        <div className="icon" onClick={() => { getActiveClass() }}>
                            <h4><IoMdMenu /></h4>
                        </div>

                        <div className="main-logo">

                            <div className="btn" style={{ width: "80%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <p> Refresh After Category Item update:- </p><button onClick={refresh} style={{backgroundColor:"black",color:"white",padding:"8px",fontSize:"14px"}}>Refresh</button>
                            </div>

                            <div className="logo">
                                <img
                                    src={img}
                                    alt="Logo"
                                    onClick={toggleDropdown}  // Toggle dropdown on image click
                                    className="logo"
                                    style={{ cursor: 'pointer' }}
                                    loading="lazy"
                                />
                            </div>
                        </div>
                        {isDropdownOpen && (
                            <div className="dropdown-menu">
                                <ul>
                                    <li onClick={handleLogout}>Logout</li>
                                    <Link to="/admin/changePass"><li>Update Password</li></Link>
                                </ul>
                            </div>
                        )}

                    </div>
                </div>
            </div>

            <LoadingWait isTrue={isLoading} />

            <SuccessPopUp
                isOpen={showPopup}
                action={action}
                FutherMore={"ok"}
                onClose={onClose}
            />
        </>
    );
}

export { Header };
